import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { DEFAULT_DELAY } from '../constants';
import { delay } from 'rxjs/internal/operators/delay';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  private subject = new BehaviorSubject<boolean>(false);

  public observable = this.subject.asObservable().pipe(
    delay(DEFAULT_DELAY)
  );

  setLoading(loading: boolean) {
    this.subject.next(loading);
  }

}
